/* eslint-disable */

import axios from 'axios';
import { extractApiError } from '@/utils/apiError';

axios.defaults.baseURL = process.env.VUE_APP_TEAMIO_API_URL;

export default {
  namespaced: true,

  state: {
    connection: null,
    loading: false,
    error: null,
    syncResult: null
  },

  getters: {
    isConnected: state => state.connection?.connected === true,
    connectionStatus: state => state.connection?.status || null
  },

  mutations: {
    setConnection(state, connection) {
      state.connection = connection;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setError(state, error) {
      state.error = error;
    },
    setSyncResult(state, result) {
      state.syncResult = result;
    }
  },

  actions: {
    async getLinkToken({ commit }, { siteID }) {
      try {
        commit('setLoading', true);
        commit('setError', null);
        const response = await axios.post('/plaid/link-token', { siteID }, { crossdomain: true });
        commit('setLoading', false);
        return response.data;
      } catch (err) {
        commit('setLoading', false);
        commit('setError', extractApiError(err));
        throw err;
      }
    },

    async getUpdateLinkToken({ commit }, { siteID }) {
      try {
        commit('setLoading', true);
        commit('setError', null);
        const response = await axios.post('/plaid/update-link-token', { siteID }, { crossdomain: true });
        commit('setLoading', false);
        return response.data;
      } catch (err) {
        commit('setLoading', false);
        commit('setError', extractApiError(err));
        throw err;
      }
    },

    async exchangeToken({ commit }, { siteID, public_token, account }) {
      try {
        commit('setLoading', true);
        commit('setError', null);
        const response = await axios.post('/plaid/exchange-token', {
          siteID, public_token, account
        }, { crossdomain: true });
        commit('setLoading', false);
        return response.data;
      } catch (err) {
        commit('setLoading', false);
        commit('setError', extractApiError(err));
        throw err;
      }
    },

    async getStatus({ commit }, { siteID }) {
      try {
        commit('setLoading', true);
        commit('setError', null);
        const response = await axios.get('/plaid/status', {
          params: { siteID },
          crossdomain: true
        });
        commit('setConnection', response.data);
        commit('setLoading', false);
        return response.data;
      } catch (err) {
        commit('setLoading', false);
        commit('setError', extractApiError(err));
        throw err;
      }
    },

    async disconnect({ commit }, { siteID }) {
      try {
        commit('setLoading', true);
        commit('setError', null);
        const response = await axios.post('/plaid/disconnect', { siteID }, { crossdomain: true });
        commit('setConnection', null);
        commit('setLoading', false);
        return response.data;
      } catch (err) {
        commit('setLoading', false);
        commit('setError', extractApiError(err));
        throw err;
      }
    },

    async syncTransactions({ commit }, { siteID }) {
      try {
        commit('setLoading', true);
        commit('setError', null);
        commit('setSyncResult', null);
        const response = await axios.post('/plaid/sync', { siteID }, { crossdomain: true });
        commit('setSyncResult', response.data);
        commit('setLoading', false);
        return response.data;
      } catch (err) {
        commit('setLoading', false);
        commit('setError', extractApiError(err));
        throw err;
      }
    }
  }
};
